import { useResilientRestQuery } from '@famly/stat_apollo-query';
import { useImmerQueryWrapper } from './use-immer-query-wrapper';
/**
 * Simply combines the `useResilientRestQuery` with the `useImmerQueryWrapper`.
 *
 * @see useResilientQuery
 * @see useImmerQueryWrapper
 */
export function useStatRestQuery(query, options) {
    return useImmerQueryWrapper(useResilientRestQuery(query, options), { skip: options === null || options === void 0 ? void 0 : options.skip });
}
